"use client"

import { useState, useEffect } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Box,
  Grid,
  Divider,
  CircularProgress,
  Alert,
  TextField,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { v4 as uuidv4 } from "uuid"
import { root_url } from "../services/API"
import Toast from "./Toast"

const SpecialProductModal = ({ open, onClose, item, onAddToCart, hotelId }) => {
  const [quantity, setQuantity] = useState(1)
  const [selectedAttributes, setSelectedAttributes] = useState({})
  const [selectedAddons, setSelectedAddons] = useState({})
  const [totalPrice, setTotalPrice] = useState(0)
  const [basePrice, setBasePrice] = useState(0)
  const [isLoadingPrice, setIsLoadingPrice] = useState(false)
  const [isLoadingAddon, setIsLoadingAddon] = useState(false)
  const [priceError, setPriceError] = useState(null)
  const [trackId, setTrackId] = useState("")
  const [specialRequest, setSpecialRequest] = useState("")
  console.log("hello+++++++++++++++++++++++++++++++++", hotelId)
  // Generate trackId when modal opens
  useEffect(() => {
    if (open && !trackId) {
      const newTrackId = uuidv4()
      setTrackId(newTrackId)
      console.log("Generated new trackId:", newTrackId)
    }
  }, [open, trackId])

  useEffect(() => {
    if (item && trackId) { // Only initialize if we have both item and trackId
      // Initialize with default price - Check for area-specific pricing first
      let initialPrice = item.menu_price

      // Get area-specific price if available (same logic as in FoodCard)
      if (Array.isArray(item.area_details) && item.area_details.length > 0) {
        const activeArea = item.area_details.find(area => area.area_status === true);
        if (activeArea && activeArea.area_final_price > 0) {
          initialPrice = activeArea.area_final_price;
        }
      }

      setBasePrice(initialPrice)
      setTotalPrice(initialPrice)

      // Initialize selected attributes with first option as default
      const initialAttributes = {}
      const initialAddons = {}

      if (item.special_details?.detailseAttribute) {
        item.special_details.detailseAttribute.forEach((attr) => {
          attr.attribute_data.forEach((data) => {
            if (data.attribute_value.length > 0) {
              initialAttributes[data.attribute_name] = data.attribute_value[0]
            }
          })
        })
      }

      // if (item.special_details?.detailseAddonFields) {
      //   item.special_details.detailseAddonFields.forEach((field) => {
      //     initialAddons[field.name] = field.options.map((option) => ({
      //       name: option.name,
      //       price: Number.parseFloat(option.price),
      //       id: option.id,
      //       selected:
      //         field.input_type === "radio"
      //           ? field.options.findIndex((opt) => opt.is_default_selected === 1) === field.options.indexOf(option)
      //             ? option.name
      //             : ""
      //           : option.is_default_selected === 1,
      //     })) 
      //   })
      // }

      if (item.special_details?.detailseAddonFields) {
        console.log("item dATA", item);
        item.special_details.detailseAddonFields.forEach((field) => {
          initialAddons[field.name] = field.options.map((option) => ({
            name: option.name,
            price: Number.parseFloat(option.price),
            id: option.id,
            selected:
              field.input_type === "radio"
                ? field.options.findIndex((opt) => opt.is_default_selected === 1) === field.options.indexOf(option)
                  ? option.name
                  : ""
                : option.is_default_selected === 1,
          }))
        })
      }
      setSelectedAttributes(initialAttributes)
      setSelectedAddons(initialAddons)

      // If we have initial attributes, check their price
      if (Object.keys(initialAttributes).length > 0) {
        checkVariationPrice(initialAttributes)
      } else {
        calculateTotalPrice(initialAddons)
      }
    }
  }, [item, trackId])

  const checkVariationPrice = async (attributeSelections) => {
    if (!item || Object.keys(attributeSelections).length === 0 || !trackId) return

    setIsLoadingPrice(true)
    setPriceError(null)

    try {
      const variationData = Object.entries(attributeSelections).map(([key, value]) => value)

      const payload = {
        hotel_id: hotelId,
        hotel_menu_id: item.id,
        variation_data: variationData,
        special_items_track_id: trackId,
      }

      const token = localStorage.getItem("token")
      console.log("Calling check-price with trackId:", trackId)

      const response = await fetch(`${root_url}/api/user/hotel-menu/variation/check-variation-price`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })

      const data = await response.json()
      console.log("Price check response:", data)

      if (data?.status === "success" && data.data) {
        let priceToUse = 0;

        // First determine the base price (from data or fallback to area price or menu price)
        if (data.data.tracked_data?.final_total) {
          priceToUse = Number.parseFloat(data.data.tracked_data.final_total);
          setBasePrice(
            Number.parseFloat(data.data.tracked_data.variation_total || data.data.price || item.menu_price || 0),
          )
        } else if (data.data.final_total) {
          priceToUse = Number.parseFloat(data.data.final_total);
          setBasePrice(Number.parseFloat(data.data.variation_total || data.data.regular_price || item.menu_price || 0))
        } else if (data.data.price) {
          priceToUse = Number.parseFloat(data.data.price);
          setBasePrice(priceToUse)
        } else {
          // No price data, check if we have area pricing
          const activeArea = item.area_details?.find(area => area.area_status === true);
          if (activeArea && activeArea.area_final_price > 0) {
            priceToUse = activeArea.area_final_price;
          } else {
            priceToUse = Number.parseFloat(item.menu_price || 0);
          }
          setBasePrice(priceToUse)
        }

        setTotalPrice(priceToUse)
      } else {
        // Fallback to area pricing or menu price if API call fails
        const activeArea = item.area_details?.find(area => area.area_status === true);
        const fallbackPrice = activeArea?.area_final_price || Number.parseFloat(item.menu_price || 0);

        setPriceError(data?.message || "Could not get updated price for this combination")
        setBasePrice(fallbackPrice)
        calculateTotalPrice(selectedAddons, fallbackPrice)
      }
    } catch (error) {
      console.error("Error checking variation price:", error)

      // Fallback to area pricing or menu price if API call fails
      const activeArea = item.area_details?.find(area => area.area_status === true);
      const fallbackPrice = activeArea?.area_final_price || Number.parseFloat(item.menu_price || 0);

      setPriceError("Error getting price. Please try again.")
      setBasePrice(fallbackPrice)
      calculateTotalPrice(selectedAddons, fallbackPrice)
    } finally {
      setIsLoadingPrice(false)
    }
  }

  // useEffect(() => {
  //   if (item && trackId) { // Only initialize if we have both item and trackId
  //     // Initialize with default price
  //     const initialPrice = item.menu_price
  //     setBasePrice(initialPrice)
  //     setTotalPrice(initialPrice)

  //     // Initialize selected attributes with first option as default
  //     const initialAttributes = {}
  //     const initialAddons = {}

  //     if (item.special_details?.detailseAttribute) {
  //       item.special_details.detailseAttribute.forEach((attr) => {
  //         attr.attribute_data.forEach((data) => {
  //           if (data.attribute_value.length > 0) {
  //             initialAttributes[data.attribute_name] = data.attribute_value[0]
  //           }
  //         })
  //       })
  //     }

  //     if (item.special_details?.detailseAddonFields) {
  //       item.special_details.detailseAddonFields.forEach((field) => {
  //         initialAddons[field.name] = field.options.map((option) => ({
  //           name: option.name,
  //           price: Number.parseFloat(option.price),
  //           id: option.id,
  //           selected:
  //             field.input_type === "radio"
  //               ? field.options.findIndex((opt) => opt.is_default_selected === 1) === field.options.indexOf(option)
  //                 ? option.name
  //                 : ""
  //               : option.is_default_selected === 1,
  //         }))
  //       })
  //     }

  //     setSelectedAttributes(initialAttributes)
  //     setSelectedAddons(initialAddons)

  //     // If we have initial attributes, check their price
  //     if (Object.keys(initialAttributes).length > 0) {
  //       checkVariationPrice(initialAttributes)
  //     } else {
  //       calculateTotalPrice(initialAddons)
  //     }
  //   }
  // }, [item, trackId]) // Changed dependency to trackId instead of open

  // const checkVariationPrice = async (attributeSelections) => {
  //   if (!item || Object.keys(attributeSelections).length === 0 || !trackId) return

  //   setIsLoadingPrice(true)
  //   setPriceError(null)

  //   try {
  //     const variationData = Object.entries(attributeSelections).map(([key, value]) => value)

  //     const payload = {
  //       hotel_id: hotelId,
  //       hotel_menu_id: item.id,
  //       variation_data: variationData,
  //       special_items_track_id: trackId,
  //     }

  //     const token = localStorage.getItem("token")
  //     console.log("Calling check-price with trackId:", trackId)

  //     const response = await fetch(`${root_url}/api/user/hotel-menu/variation/check-variation-price`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(payload),
  //     })

  //     const data = await response.json()
  //     console.log("Price check response:", data)

  //     if (data?.status === "success" && data.data) {
  //       if (data.data.tracked_data?.final_total) {
  //         setTotalPrice(Number.parseFloat(data.data.tracked_data.final_total))
  //         setBasePrice(
  //           Number.parseFloat(data.data.tracked_data.variation_total || data.data.price || item.menu_price || 0),
  //         )
  //       } else if (data.data.final_total) {
  //         setTotalPrice(Number.parseFloat(data.data.final_total))
  //         setBasePrice(Number.parseFloat(data.data.variation_total || data.data.regular_price || item.menu_price || 0))
  //       } else if (data.data.price) {
  //         setBasePrice(Number.parseFloat(data.data.price))
  //         calculateTotalPrice(selectedAddons, Number.parseFloat(data.data.price))
  //       }
  //     } else {
  //       setPriceError(data?.message || "Could not get updated price for this combination")
  //       setBasePrice(Number.parseFloat(item.menu_price || 0))
  //       calculateTotalPrice(selectedAddons, Number.parseFloat(item.menu_price || 0))
  //     }
  //   } catch (error) {
  //     console.error("Error checking variation price:", error)
  //     setPriceError("Error getting price. Please try again.")
  //     setBasePrice(Number.parseFloat(item.menu_price || 0))
  //     calculateTotalPrice(selectedAddons, Number.parseFloat(item.menu_price || 0))
  //   } finally {
  //     setIsLoadingPrice(false)
  //   }
  // }

  const checkOrUncheckAddon = async (addonFieldId, addonFieldOptionId, isSelected) => {
    if (!item || !trackId) return false

    console.log("Calling addon API with trackId:", trackId)
    setIsLoadingAddon(true)
    const token = localStorage.getItem("token")

    try {
      const payload = {
        special_items_track_id: trackId,
        hotel_id: hotelId,
        hotel_menu_id: item.id,
        addon_field_id: addonFieldId,
        addon_field_option_id: addonFieldOptionId,
        is_selected: isSelected ? 1 : 0,
      }

      const response = await fetch(`${root_url}/api/user/hotel-menu/addonFields/check-or-uncheck`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })

      const data = await response.json()
      console.log("Addon check response:", data)

      if (data?.status === "success" && data.data) {
        if (data.data.tracked_data?.final_total !== undefined) {
          setTotalPrice(Number.parseFloat(data.data.tracked_data.final_total))
          setBasePrice(
            Number.parseFloat(data.data.tracked_data.variation_total || data.data.price || item.menu_price || 0),
          )
        } else if (data.data.price) {
          setBasePrice(Number.parseFloat(data.data.price))
          calculateTotalPrice(selectedAddons, Number.parseFloat(data.data.price))
        }
      }

      return true
    } catch (error) {
      console.error("Error checking addon:", error)
      return false
    } finally {
      setIsLoadingAddon(false)
    }
  }

  const calculateTotalPrice = (addons, base = basePrice) => {
    if (!item) return

    let newTotal = base

    // Add addon prices
    Object.values(addons).forEach((addon) => {
      if (Array.isArray(addon)) {
        // For checkboxes (multiple selections)
        addon.forEach((option) => {
          if (option.selected) {
            newTotal += Number.parseFloat(option.price || 0)
          }
        })
      } else if (addon) {
        // For dropdowns (single selection)
        newTotal += Number.parseFloat(addon.price || 0)
      }
    })

    setTotalPrice(newTotal)
  }

  const handleQuantityChange = (change) => {
    const newQuantity = Math.max(1, quantity + change)
    setQuantity(newQuantity)
  }

  const handleAttributeChange = (attributeName, value) => {
    // Update the selected attributes
    const updatedAttributes = {
      ...selectedAttributes,
      [attributeName]: value,
    }

    setSelectedAttributes(updatedAttributes)

    // Check the price for the new combination
    checkVariationPrice(updatedAttributes)
  }

  const handleAddonChange = async (fieldName, optionIndex, inputType, value) => {
    const updatedAddons = { ...selectedAddons }
    const addonField = item.special_details?.detailseAddonFields.find((field) => field.name === fieldName)

    if (!addonField) return

    const addonOption = addonField.options[optionIndex]

    if (inputType === "checkbox") {
      // Toggle the selected state
      const isSelected = !updatedAddons[fieldName][optionIndex].selected
      updatedAddons[fieldName][optionIndex].selected = isSelected

      // Update UI optimistically
      setSelectedAddons(updatedAddons)

      // Call API to check/uncheck addon
      await checkOrUncheckAddon(addonField.id, addonOption.id, isSelected)
    } else if (inputType === "radio" || inputType === "dropdown") {
      // For radio buttons and dropdowns, deselect all options in this field first
      updatedAddons[fieldName].forEach((option, idx) => {
        const wasSelected = option.selected === option.name
        option.selected = idx === optionIndex ? value : ""

        // If there was a change in selection, call the API
        if (idx === optionIndex && value && !wasSelected) {
          // Call API to check this option
          setTimeout(() => {
            checkOrUncheckAddon(addonField.id, addonOption.id, true)
          }, 0)
        } else if (idx !== optionIndex && wasSelected) {
          // Call API to uncheck the previously selected option
          setTimeout(() => {
            checkOrUncheckAddon(addonField.id, addonField.options[idx].id, false)
          }, 0)
        }
      })

      // Update UI immediately
      setSelectedAddons(updatedAddons)
    }
  }

  const handleAddToCart = () => {
    if (!item) return

    // Check if all required addons are selected
    const requiredAddons = item.special_details?.detailseAddonFields?.filter((addon) => addon.is_required === 1) || []

    const missingRequiredAddons = requiredAddons.filter((addon) => {
      const selection = selectedAddons[addon.name]
      if (!selection) return true

      if (addon.input_type === "checkbox") {
        return !selection.some((opt) => opt.selected)
      } else {
        return !selection.some((opt) => opt.selected === opt.name)
      }
    })

    if (missingRequiredAddons.length > 0) {
      alert(`Please select required options: ${missingRequiredAddons.map((a) => a.name).join(", ")}`)
      return
    }

    // Prepare selected attributes in a readable format
    const formattedAttributes = Object.entries(selectedAttributes).map(([name, value]) => ({
      name,
      value,
    }))

    // Prepare selected addons in a readable format
    const formattedAddons = Object.entries(selectedAddons)
      .map(([fieldName, options]) => ({
        fieldName,
        options: options
          .filter(
            (option) =>
              (typeof option.selected === "boolean" && option.selected) ||
              (typeof option.selected === "string" && option.selected === option.name),
          )
          .map((option) => ({
            name: option.name,
            price: option.price,
            id: option.id,
          })),
      }))
      .filter((field) => field.options.length > 0)

    // Get area-specific pricing information (if available)
    const activeArea = item.area_details?.find(area => area.area_status === true)
    const hasAreaPricing = activeArea && activeArea.area_final_price > 0

    // Create the cart item
    const cartItem = {
      ...item,
      quantity,
      isSpecial: true,
      selectedAttributes: formattedAttributes,
      selectedAddons: formattedAddons,
      itemTotalPrice: totalPrice,
      basePrice: basePrice,
      currentPrice: totalPrice, // Add currentPrice for consistency with regular items
      trackId: trackId,
      specialRequest: specialRequest,
      // Store the area pricing information
      area_pricing: hasAreaPricing ? {
        area_id: activeArea.area_id,
        area_name: activeArea.area_name,
        area_final_price: activeArea.area_final_price
      } : null
    }

    onAddToCart(cartItem)
    onClose()
  }
  // const handleAddToCart = () => {
  //   if (!item) return

  //   // Check if all required addons are selected
  //   const requiredAddons = item.special_details?.detailseAddonFields?.filter((addon) => addon.is_required === 1) || []

  //   const missingRequiredAddons = requiredAddons.filter((addon) => {
  //     const selection = selectedAddons[addon.name]
  //     if (!selection) return true

  //     if (addon.input_type === "checkbox") {
  //       return !selection.some((opt) => opt.selected)
  //     } else {
  //       return !selection.some((opt) => opt.selected === opt.name)
  //     }
  //   })

  //   if (missingRequiredAddons.length > 0) {
  //     alert(`Please select required options: ${missingRequiredAddons.map((a) => a.name).join(", ")}`)
  //     return
  //   }

  //   // Prepare selected attributes in a readable format
  //   const formattedAttributes = Object.entries(selectedAttributes).map(([name, value]) => ({
  //     name,
  //     value,
  //   }))

  //   // Prepare selected addons in a readable format
  //   const formattedAddons = Object.entries(selectedAddons)
  //     .map(([fieldName, options]) => ({
  //       fieldName,
  //       options: options
  //         .filter(
  //           (option) =>
  //             (typeof option.selected === "boolean" && option.selected) ||
  //             (typeof option.selected === "string" && option.selected === option.name),
  //         )
  //         .map((option) => ({
  //           name: option.name,
  //           price: option.price,
  //           id: option.id,
  //         })),
  //     }))
  //     .filter((field) => field.options.length > 0)

  //   // Create the cart item
  //   const cartItem = {
  //     ...item,
  //     quantity,
  //     isSpecial: true,
  //     selectedAttributes: formattedAttributes,
  //     selectedAddons: formattedAddons,
  //     itemTotalPrice: totalPrice,
  //     basePrice: basePrice,
  //     trackId: trackId, // Include the track ID for reference
  //     specialRequest: specialRequest, // Add the special request
  //   }

  //   onAddToCart(cartItem)
  //   onClose()
  // }
  if (!item) return null

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: "#02111B",
          backgroundImage: "none",
          color: "white",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: "700" }}>
          {item.menu_name}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ borderColor: "rgba(255, 255, 255, 0.1)", p: 3 }}>
        <Grid container spacing={3}>
          {/* Left side - Image */}


          {/* Right side - Attributes and Addons */}
          <Grid item xs={12} >
            {/* Attributes Section */}
            {item.special_details?.detailseAttribute && item.special_details.detailseAttribute.length > 0 && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: "600" }}>
                  Variations
                </Typography>

                {item.special_details.detailseAttribute.map((attrGroup, groupIndex) => (
                  <Box key={groupIndex} sx={{ mb: 2 }}>
                    {attrGroup.attribute_data.map((attr, attrIndex) => (
                      <Box key={attrIndex} sx={{ mb: 2 }}>
                        <Typography sx={{ mb: 1, fontWeight: "500" }}>{attr.attribute_name}</Typography>

                        <FormControl component="fieldset" fullWidth>
                          <RadioGroup
                            value={selectedAttributes[attr.attribute_name] || ""}
                            onChange={(e) => handleAttributeChange(attr.attribute_name, e.target.value)}
                          >
                            <Grid container spacing={1}>
                              {attr.attribute_value.map((value, valueIndex) => (
                                <Grid item xs={6} sm={4} key={valueIndex}>
                                  <FormControlLabel
                                    value={value}
                                    control={
                                      <Radio
                                        sx={{
                                          color: "rgba(255, 255, 255, 0.7)",
                                          "&.Mui-checked": {
                                            color: "#FFC857",
                                          },
                                        }}
                                        disabled={isLoadingPrice}
                                      />
                                    }
                                    label={value}
                                    sx={{
                                      border: "1px solid rgba(255, 255, 255, 0.2)",
                                      borderRadius: "4px",
                                      m: 0,
                                      p: 1,
                                      width: "100%",
                                      "&:hover": {
                                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                                      },
                                    }}
                                  />
                                </Grid>
                              ))}
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}

            {/* Divider between sections */}
            {item.special_details?.detailseAttribute &&
              item.special_details.detailseAttribute.length > 0 &&
              item.special_details?.detailseAddonFields &&
              item.special_details.detailseAddonFields.length > 0 && (
                <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.1)", my: 3 }} />
              )}

            {/* Addons Section */}
            {item.special_details?.detailseAddonFields && item.special_details.detailseAddonFields.length > 0 && (
              <Box>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: "600" }}>
                  Add-ons
                </Typography>

                {item.special_details.detailseAddonFields.map((field, fieldIndex) => (
                  <Box key={fieldIndex} sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography
                        sx={{
                          fontWeight: field.title_format === "heading" ? "600" : "500",
                          fontSize: field.title_format === "heading" ? "1rem" : "0.9rem",
                        }}
                      >
                        {field.name}
                        {field.is_required === 1 && <span style={{ color: "#f44336", marginLeft: "4px" }}>*</span>}
                      </Typography>
                    </Box>

                    {field.description && (
                      <Typography variant="body2" sx={{ mb: 1, color: "rgba(255, 255, 255, 0.7)" }}>
                        {field.description}
                      </Typography>
                    )}

                    <FormControl fullWidth sx={{ mt: 1 }}>
                      {field.input_type === "checkbox" && (
                        <Grid container spacing={1}>
                          {field.options.map((option, optionIndex) => (
                            <Grid item xs={12} sm={6} key={optionIndex}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  border: "1px solid rgba(255, 255, 255, 0.2)",
                                  borderRadius: "4px",
                                  p: 1,
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                                  },
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={!!selectedAddons[field.name]?.[optionIndex]?.selected}
                                      onChange={() => handleAddonChange(field.name, optionIndex, "checkbox", null)}
                                      sx={{
                                        color: "rgba(255, 255, 255, 0.7)",
                                        "&.Mui-checked": {
                                          color: "#FFC857",
                                        },
                                      }}
                                      disabled={isLoadingAddon}
                                    />
                                  }
                                  label={option.name}
                                  sx={{ m: 0 }}
                                />
                                <Typography>+₹{Number.parseFloat(option.price).toFixed(2)}</Typography>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {field.input_type === "radio" && (
                        <RadioGroup
                          value={
                            selectedAddons[field.name]?.find(
                              (opt) => typeof opt.selected === "string" && opt.selected === opt.name,
                            )?.name || ""
                          }
                        >
                          <Grid container spacing={1}>
                            {field.options.map((option, optionIndex) => (
                              <Grid item xs={12} sm={6} key={optionIndex}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "1px solid rgba(255, 255, 255, 0.2)",
                                    borderRadius: "4px",
                                    p: 1,
                                    "&:hover": {
                                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                                    },
                                  }}
                                >
                                  <FormControlLabel
                                    value={option.name}
                                    control={
                                      <Radio
                                        onChange={() =>
                                          handleAddonChange(field.name, optionIndex, "radio", option.name)
                                        }
                                        sx={{
                                          color: "rgba(255, 255, 255, 0.7)",
                                          "&.Mui-checked": {
                                            color: "#FFC857",
                                          },
                                        }}
                                        disabled={isLoadingAddon}
                                      />
                                    }
                                    label={option.name}
                                    sx={{ m: 0 }}
                                  />
                                  <Typography>+₹{Number.parseFloat(option.price).toFixed(2)}</Typography>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </RadioGroup>
                      )}

                      {field.input_type === "dropdown" && (
                        <Select
                          value={
                            selectedAddons[field.name]?.find(
                              (opt) => typeof opt.selected === "string" && opt.selected === opt.name,
                            )?.name || ""
                          }
                          onChange={(e) => {
                            const selectedIndex = field.options.findIndex((opt) => opt.name === e.target.value)
                            if (selectedIndex !== -1) {
                              handleAddonChange(field.name, selectedIndex, "dropdown", e.target.value)
                            }
                          }}
                          sx={{
                            color: "white",
                            ".MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(255, 255, 255, 0.2)",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(255, 255, 255, 0.3)",
                            },
                            ".MuiSvgIcon-root": {
                              color: "white",
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                bgcolor: "#02111B",
                                color: "white",
                              },
                            },
                          }}
                          disabled={isLoadingAddon}
                        >
                          <MenuItem value="">
                            <em>Select an option</em>
                          </MenuItem>
                          {field.options.map((option, optionIndex) => (
                            <MenuItem value={option.name} key={optionIndex}>
                              {option.name} (+₹{Number.parseFloat(option.price).toFixed(2)})
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </FormControl>
                  </Box>
                ))}
              </Box>
            )}

            {/* Selected Options Summary */}

            {/* Special Request Section */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: "600" }}>
                Special Request
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                placeholder="Add any special instructions for this item..."
                value={specialRequest}
                onChange={(e) => setSpecialRequest(e.target.value)}
                sx={{
                  backgroundColor: "#02111B",
                  borderRadius: "4px",

                }}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          p: 2,
          justifyContent: "space-between",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          alignItems: "center",
          flexDirection: { xs: 'column', sm: 'row' }, // Stack on mobile, row on larger screens
          gap: { xs: 2, sm: 0 }, // Add gap when stacked
        }}
      >
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          flexWrap: 'wrap', // Allow items to wrap
          justifyContent: { xs: 'center', sm: 'flex-start' } // Center on mobile
        }}>
          <Typography variant="h6" sx={{
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            order: { xs: 1, sm: 0 } // Reorder for mobile
          }}>
            ₹{totalPrice}
          </Typography>

          {/* Quantity Selector */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "4px",
              order: { xs: 3, sm: 0 } // Move to bottom on mobile
            }}
          >
            <Button
              onClick={() => handleQuantityChange(-1)}
              sx={{
                minWidth: "40px",
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              -
            </Button>
            <Typography sx={{ px: 2 }}>{quantity}</Typography>
            <Button
              onClick={() => handleQuantityChange(1)}
              sx={{
                minWidth: "40px",
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              +
            </Button>
          </Box>

          {/* Total Price */}
          <Typography variant="h6" sx={{
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            order: { xs: 2, sm: 0 } // Move to middle on mobile
          }}>
            Total: ₹{(totalPrice * quantity).toFixed(2)}
          </Typography>
        </Box>

        {/* Add to Cart Button */}
        <Button
          onClick={handleAddToCart}
          variant="contained"
          disabled={isLoadingPrice || isLoadingAddon}
          sx={{
            backgroundColor: "#FFC857",
            color: "#02111B",
            fontWeight: "700",
            px: 3,
            width: { xs: '100%', sm: 'auto' }, // Full width on mobile
            "&:hover": {
              backgroundColor: "#E6B54E",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(255, 200, 87, 0.5)",
              color: "rgba(2, 17, 27, 0.7)",
            },
          }}
        >
          {isLoadingPrice || isLoadingAddon ? "Loading..." : "Add to Cart"}
        </Button>

        {/* Price error message */}
        {priceError && (
          <Alert
            severity="error"
            sx={{
              mt: 2,
              backgroundColor: "rgba(211, 47, 47, 0.1)",
              color: "#f44336",
              position: "absolute",
              bottom: "100%",
              left: 16,
              width: "calc(100% - 32px)",
            }}
          >
            {priceError}
          </Alert>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default SpecialProductModal